{
  "nl": {
    "dashboard": {
      "greetings": {
        "afternoon": "Goedemiddag {first_name}",
        "evening": "Goedenavond {first_name}",
        "morning": "Goedemorgen {first_name}",
        "night": "Goedenacht {first_name}"
      },
      "milestones": {
        "action_title_decision": "Kies {name}",
        "action_title_survey": "Vul {name} in",
        "action_title_ticket": "Nieuw bericht over {name}",
        "count_open": "{count} open",
        "journey_hide": "Projecttraject verbergen",
        "journey_show": "Bekijk het projecttraject",
        "journey_step_active": "Bezig",
        "journey_step_completed": "Afgerond",
        "journey_step_planned": "Gepland",
        "other_empty_subtitle": "{client} laat je weten zodra er iets voor jou klaarstaat.",
        "other_empty_title": "Je bent helemaal bij",
        "other_promoted_title": "Vraagt jouw aandacht",
        "other_title": "Andere acties",
        "stage_done_subtitle": "{client} laat je weten wanneer de volgende stap komt.",
        "stage_done_title": "Alles klaar voor deze fase",
        "stage_empty": "Momenteel niets te doen in deze fase.",
        "stage_eyebrow": "Huidige fase",
        "stage_final_subtitle": "Alle stappen van je project zijn afgerond. We houden je op de hoogte als er nog iets verandert.",
        "stage_final_title": "Je bent helemaal klaar",
        "stage_last": "Dit is de laatste fase",
        "stage_next": "Hierna: {phase}",
        "stage_position": "Fase {current} van {total}",
        "stage_todo_title": "Om deze fase af te ronden"
      },
      "titles": {
        "activityFeed": "Activiteiten",
        "assignedTasks": "Mijn Taken",
        "newsFeed": "Nieuwsoverzicht",
        "ongoingTickets": "In Behandeling",
        "openTickets": "Open",
        "progress": "Voortgang",
        "tickets": "Gesprekken",
        "totalTickets": "Alle gesprekken",
        "unreadTickets": "Ongelezen",
        "yourAssignedTickets": "Aan jou toegewezen"
      }
    }
  }
}
